import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { SearchService } from '../../services/search.service';
import { AuthService } from '../../services/auth.service';
import { FeatureService } from 'src/app/service/feature.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CrudService } from 'src/app/service/crud.service';
import { ToastService } from 'src/app/service/toast.service';
import { NgModule } from '@angular/core';
import { FormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  tempMsg: any = {}
  sessionData: any = {}
  notifications: any[];
  changepwd: any = {};

  constructor(
    private navService: NavigationService,
    public searchService: SearchService,
    private auth: AuthService,
    public featureService: FeatureService,
    private modalService: NgbModal,
    private crud: CrudService,
    public router: Router,
    private route: ActivatedRoute,
    public toastService: ToastService,
  ) {
  }

  ngOnInit() {
    this.crud.get("myDetail").subscribe(response => {
      this.sessionData = response;      
      localStorage.logged_user_name = this.sessionData.name;
      localStorage.token = this.sessionData.userToken
      localStorage.tenant = this.sessionData.tenant;
      localStorage.academicMonth = this.sessionData.academicMonth;
      this.featureService.setFeatures(this.sessionData.features);
    }, error => {
      this.tempMsg = error;
      this.toastService.error(this.tempMsg.error.errors);
      this.router.navigateByUrl('/signin');
    })
  }

  ngOnDestroy() {
  this.modalService.dismissAll();
  }

  toggelSidebar() {
    let state = this.navService.sidebarState;
    if (!state.sidenavOpen) {
      return state.sidenavOpen = true;
    }
    if (state.childnavOpen && state.sidenavOpen) {
      return state.childnavOpen = false;
    }
    if (!state.childnavOpen && state.sidenavOpen) {
      return state.sidenavOpen = false;
    }
  }

  signout() {
    localStorage.clear();
    this.router.navigateByUrl('/signin')
  }

  openChangePassword(modalContent) {
    this.changepwd = {};
    this.modalService.open(modalContent, {
      ariaLabelledBy: 'modal-basic-title'
    })
      .result.then((result) => { }, (reason) => {
      });
  }

  saveChangePassword(data) {
    this.crud.post("changePassword", data).subscribe(response => {
      this.tempMsg = response;
      this.toastService.success(this.tempMsg.message);
      this.modalService.dismissAll();
      this.router.navigateByUrl('/signin')
    }, error => {
      this.tempMsg = error;
      this.toastService.error(this.tempMsg.error.errors);
    })
  }

  cancel() {
    this.modalService.dismissAll();
  }

  go_home() {
    this.router.navigate([this.featureService.get_home()]);
  }

}
